import { Button } from "@material-ui/core";
import { Search as SearchIcon } from '@material-ui/icons';


interface IProps {
    type: 'button' | 'submit' | 'reset'
    size?: 'small' | 'medium' | 'large'
    onClick?: () => void
}

let SearchButton = ({ type, size = 'medium', onClick }: IProps) => {
    return (
        <Button
            type={type}
            variant="contained"
            size={size}
            color="secondary"
            onClick={type === "button" ? onClick : undefined}
        >
            <SearchIcon />
        </Button>
    )
}

export default SearchButton;